import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InsuranceCarriers } from 'src/app/models/InsuranceCarriers';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { Observable } from 'rxjs';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {
  temppage: number = 0;    
  pageField = [];
  exactPageList: any;  

  constructor(private http: HttpClient) { }

  // Get all Insurances
  getallInsurences(): Observable<InsuranceCarriers[]> {
    return this.http.get<InsuranceCarriers[]>(`${configuration.apiUrl + 'Master/InsuranceCarriers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getallInsurancesPagination(pageNo,pageSize,searchTerm): Observable<InsuranceCarriers[]> {
    const posteddata={
      userid:encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility:sessionStorage.getItem("FacilityId"),
      pageNo:pageNo,
      pageSize:pageSize,
      searchTerm:searchTerm
    }
    return this.http.post<InsuranceCarriers[]>(`${configuration.apiUrl + 'Master/InsuranceCarriersPaginator'}`,posteddata);
  }
  getCountInsurance(searchTerm): Observable<any> {
    const posteddate={
      userid:encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility:sessionStorage.getItem("FacilityId"),
      searchTerm:searchTerm
    }
    return this.http.post<any>(`${configuration.apiUrl + 'Master/GetCountInsuranceCarriers'}`,posteddate);
  }

  //Save Insurance Details
  saveInsurencesDetails(insuranceInfo: InsuranceCarriers): Observable<string> {
    const posteddata={
      inputdata:JSON.stringify(insuranceInfo)
    } 
    return this.http.post<string>(`${configuration.apiUrl + 'Master/InsuranceCarriers'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

   // Update Insurance Details 
   updateInsurencesDetails(insuranceInfo: InsuranceCarriers): Observable<string> {
    const posteddata={
      inputdata:JSON.stringify(insuranceInfo)
    } 
    return this.http.post<string>(`${configuration.apiUrl + 'Master/UpdateInsuranceCarriers'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Scoped save for the Facility Enrollment panel - updates ONLY IsFacilityEnrolled/FacilityEnrollmentDate
  updateFacilityEnrollment(insuranceCarrierId: number, isFacilityEnrolled: boolean, facilityEnrollmentDate: string): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify({
        insuranceCarrierId: insuranceCarrierId,
        isFacilityEnrolled: isFacilityEnrolled,
        facilityEnrollmentDate: isFacilityEnrolled ? facilityEnrollmentDate : null,
        modifiedBy: sessionStorage.getItem("userId")
      })
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/UpdateFacilityEnrollment'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //Get CC payers
  getCCPayers(claimType:string, payer:string): Observable<InsuranceCarriers[]> {
    return this.http.get<InsuranceCarriers[]>(`${configuration.apiUrl + 'Master/CCPayers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&claimType=${claimType}&&payer=${payer}`);
  }

  pageOnLoad() {
    if (this.temppage == 0) {
      this.pageField = [];
      for (var a = 0; a < this.exactPageList; a++) {
        this.pageField[a] = this.temppage + 1;
        this.temppage = this.temppage + 1;
      }
    }
  }
}
